<template>
  <div class="container">
    <div class="mb-8">
      <slot name="heading"></slot>
      <p class="text-black-light-5 mb-4">
        Sign up to ZuBlu's newsletter and get access to exclusive special
        offers, destination inspiration, and expert travel advice for your next
        scuba diving holiday.
      </p>
      <Link
        text="back to booking enquiry"
        :leftIcon="true"
        href="/enquiry"
        @click="onBack"
      />
    </div>
    <div class="enquiry-form">
      <validation-observer tag="div" ref="valiObjserver">
        <form @submit.prevent="onBeforeSubmit">
          <label class="block mb-8">
            <p class="mb-2 fs-14">First name</p>
            <validation-provider
              ref="First Name"
              name="First Name"
              rules="required"
              v-slot="{ errors }"
            >
              <input
                class="input input-tall w-full"
                :class="{ 'input--error': errors[0] }"
                v-model="firstName"
              />
              <span class="fs-14 text-danger mt-1">{{ errors[0] }}</span>
            </validation-provider>
          </label>

          <label class="block mb-8">
            <p class="mb-2 fs-14">Last name</p>
            <validation-provider
              ref="Last Name"
              name="Last Name"
              rules="required"
              v-slot="{ errors }"
            >
              <input
                class="input input-tall w-full"
                :class="{ 'input--error': errors[0] }"
                v-model="lastName"
              />
              <span class="fs-14 text-danger mt-1">{{ errors[0] }}</span>
            </validation-provider>
          </label>

          <label class="block mb-8">
            <p class="mb-2 fs-14">Email</p>
            <validation-provider
              ref="Email"
              name="Email"
              rules="required|email"
              v-slot="{ errors }"
            >
              <input
                class="input input-tall w-full"
                :class="{ 'input--error': errors[0] }"
                v-model.lazy="email"
              />
              <span class="fs-14 text-danger mt-1">{{ errors[0] }}</span>
            </validation-provider>
          </label>

          <button
            class="mt-8 btn btn-primary input-tall font-medium sm:w-full sm:justify-center flex items-center"
            :disabled="isWorking"
            :class="isWorking ? 'loading' : ''"
          >
            Subscribe
            <div class="zb-spin"></div>
          </button>
        </form>
      </validation-observer>
    </div>
  </div>
</template>

<script>
import { ValidationProvider, ValidationObserver } from "vee-validate";
import Link from "../../components/core/Link";
const fieldsOrder = ["First Name", "Last Name", "Email"];

export default {
  components: {
    ValidationProvider,
    ValidationObserver,
    Link,
  },
  name: "Enquiry",
  props: {
    onBack: {
      type: Function,
      default: () => {},
    },
  },
  data() {
    return {
      isWorking: false,
      firstName: "",
      lastName: "",
      email: "",
      formSubmitted: false,
    };
  },
  methods: {
    onBeforeSubmit() {
      const valid = this.$refs.valiObjserver.validate().then((result) => {
        if (result === false) {
          setTimeout(() => {
            const errors = JSON.parse(
              JSON.stringify(this.$refs.valiObjserver.errors)
            );

            for (const field of fieldsOrder) {
              if (errors[field] && errors[field].length) {
                this.$refs[field].$el.scrollIntoView({
                  behavior: "smooth",
                  block: "center",
                });
                break;
              }
            }
          }, 100); //https://github.com/logaretm/vee-validate/issues/2248
        } else {
          this.onSubmit();
        }
      });
    },
    onSubmit() {
      this.formSubmitted = true;

      const form = document.getElementById("form");
      const thankyou = document.getElementById("thankyou");
      const thankyoumessage = document.getElementById("thankyoumessage");

      const payload = {
        first_name: this.firstName,
        last_name: this.lastName,
        email: this.email,
        type: "newsletter",
      };

      console.log(
        payload,
        window.Craft.csrfTokenValue,
        window.Craft.session.landing_page,
        window.location.href
      );

      this.isWorking = true;
      $.ajax({
        method: "POST",
        url: "/",
        data: {
          action: "zuBlu/form/subscribe",
          [window.Craft.csrfTokenName]: window.Craft.csrfTokenValue,
          formData: {
            first_name: this.firstName,
            last_name: this.lastName,
            email: this.email,
            url: window.Craft.session.landing_page || window.location.href,
            Lead_Source: "Mailing List Subscription",
          },
        },
        headers: { "Content-Type": "application/x-www-form-urlencoded" },
      })
        .done(() => {
          thankyoumessage.innerText = `Thanks for subscribing`;
          form.classList.add("hidden");
          window.scrollTo(0, thankyou);
          thankyou.classList.remove("hidden");
        })
        .fail((e) => {
          console.log(e);
          this.isWorking = false;
        });
    },
  },
};
</script>

<style lang="scss" scoped>
button {
  .zb-spin {
    display: none;
  }
  &.loading {
    .zb-spin {
      display: inline-block;
    }
  }
}
</style>
